import { QueryClient, useQuery } from '@tanstack/react-query'
import { dashboardClient } from '@/api'

export const useCurrentCampaignVersionQuery = (companyId: string, gameId: string, campaignId: string) => {
  return useQuery({
    queryKey: ['current-campaign-version', gameId, campaignId],
    queryFn: () => dashboardClient.v1.getCurrentCampaignVersion(companyId, gameId, campaignId).then(r => r.data),
  })
}

export const refetchCurrentCampaignVersion = (ql: QueryClient) => {
  ql.refetchQueries({ queryKey: ['current-campaign-version'], exact: false })
}
